import { GetOrderRequest, type OrderItem } from '@app/_proto/Protos/orders';
import { OrdersClient } from '@app/_proto/Protos/orders.client';
import { useGrpcRequest } from '@app/libs/grpc';
import { useHttp } from '@app/libs/http';
import { Global } from '@emotion/react';
import { CircularProgress } from '@mui/material';
import { backOff } from 'exponential-backoff';
import * as React from 'react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

export type ProductSuccessProps = {
    enabled: boolean;
    message?: string;
    order: OrderItem | null;
    onOrderCompleted: (order: OrderItem) => void;
};

export default function ProductSuccess({ enabled, order, onOrderCompleted }: ProductSuccessProps) {
    const request = useGrpcRequest(GetOrderRequest, {
        id: order?.id,
    });

    const { grpcRequest } = useHttp();

    useEffect(() => {
        const waitForActivation = async () => {
            const orderData = await grpcRequest(OrdersClient, c => c.getOrder, request);

            if (orderData?.item && orderData.item.completed) {
                onOrderCompleted?.(orderData.item);
            } else {
                throw new Error('activation failed');
            }
        };

        if (enabled) {
            backOff(waitForActivation, {
                delayFirstAttempt: false,
                startingDelay: 1000 * 5,
                numOfAttempts: 5,
            });
        }
    }, [enabled, grpcRequest, onOrderCompleted, request]);

    if (!enabled) {
        return null;
    }

    return ReactDOM.createPortal(
        <>
            <Global styles={{ body: { overflow: 'hidden' } }} />
            <div className="fixed top-0 left-0 right-0 bottom-0 z-[1201] h-full w-full overflow-hidden bg-black bg-opacity-50"></div>
            <div className="fixed top-0 left-0 right-0 bottom-0 z-[1202] overflow-hidden px-[30px]">
                <div className="flex h-full w-full items-center justify-center">
                    <div className="flex flex-col items-center justify-center space-y-[30px]">
                        <CircularProgress className="text-white" />
                        <p className="text-center font-extrabold text-white">
                            Please wait, your request is being processed
                        </p>
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
}
